import { payMoveInEndPoint, payReserveEndPoint } from './config';
import { AccountPanelTypes } from '../../account';
import { getDecimalBalance } from '../../account/helpers/accountPanelHelper';
import { currentBalanceNotAvailable } from '../../account/constants/accountPanelConfigs';
import { getPaymentMethodInfo } from '../../account/helpers/PaymentHelpers';
import {
  fetchPaymentInfo,
  fetchSmsConfigurations,
} from '@codeparva/v11-tfw-api-library';

export const paymentRequestHandler = async (
  paymentComponentReq: any,
  gatsbyPathName: string,
  facilityId: string,
  facPublicKey: string,
  callBackHandler?: AccountPanelTypes.TCallBackHandler,
  contextData?: any
) => {
  const [
    ,
    {
      data: {
        data: {
          Payment_Method: paymentMethodInfo = {},
          Card_Processor: cardProcessorInfo = {},
        } = {},
      } = {},
    } = {},
  ] = await fetchSmsConfigurations({
    configTypes: ['Payment_Method', 'Card_Processor'],
    facilityId,
    facPublicKey,
  });
  const { encryptionKey } = contextData;
  const moveInConfig = paymentComponentReq.move_in || {};
  const reservationConfig = paymentComponentReq.reserve || {};
  const reservationConfigs = {
    url: {
      reservation: payReserveEndPoint,
    },
    total_amount: paymentComponentReq.total_amount,
    isReservation: gatsbyPathName.includes('reserve') ? true : false,
    isMoveIn: gatsbyPathName.includes('move-in') ? true : false,
    data: {
      ledger_id: paymentComponentReq.ledgerIdFromSMS || '',
    },
    reservation: reservationConfig,
  };
  const moveInConfigs = {
    url: {
      movein: payMoveInEndPoint,
    },
    total_amount: paymentComponentReq.total_amount,
    isReservation: gatsbyPathName.includes('reserve') ? true : false,
    isMoveIn: gatsbyPathName.includes('move-in') ? true : false,
    data: {
      ledger_id: paymentComponentReq.ledgerIdFromSMS,
    },
    move_in: moveInConfig || {},
  };

  const isSurchargeOrDiscountAvailable = checkForSurchargeOrDiscount(
    paymentMethodInfo.data
  );
  return {
    callBackHandler,
    public_key: facPublicKey,
    payment_method: paymentMethodInfo,
    cardProcessorIds: cardProcessorInfo,
    configs: {
      total_amount: paymentComponentReq.total_amount,
      reservationConfigs,
      moveInConfigs,
      encryptionKey,
    },
    facilityId: facilityId,
    tenantId: '',
    tenantIdFromCreationAPI: '',
    individualUnitData: {},
    contextData: {},
    isSurchargeOrDiscountAvailable,
  };
};

export const getUpdatedAmount = async (
  payment_method_id: any,
  amount: any,
  facilityId: string,
  tenantToken: string | undefined
) => {
  const numAmount = parseFloat(amount);
  const [
    ,
    {
      data: {
        data: {
          amount: amountFromResponse = 0,
          surcharge_or_discount = '',
          amount_without_modifier = 0,
          modifier = '',
        } = {},
      } = {},
    } = {},
  ] = await fetchPaymentInfo({
    paymentInfoReq: {
      payment_method_id: payment_method_id,
      amount_without_modifier: numAmount,
    },
    facilityId,
    tenantToken,
  });
  return {
    amount: amountFromResponse,
    surcharge_or_discount,
    amount_without_modifier,
    modifier,
  };
};

export const checkForSurchargeOrDiscount = (data: any) => {
  for (const item of data) {
    const modifier = getPaymentMethodInfo(item, 'modifier');
    if (modifier === 'Surcharge' || modifier === 'Discount') {
      return true;
    }
  }
  return false;
};

export const getPathName = (originalPath: string, endPathName: string) => {
  const originalPathWithNoSlash = originalPath.replace(/\/+$/, '');
  const paymentPathWithNoSlash = endPathName.replace(/\/+$/, '');
  if (originalPathWithNoSlash.endsWith(paymentPathWithNoSlash)) {
    return originalPathWithNoSlash.slice(
      0,
      -(paymentPathWithNoSlash.length + 1)
    );
  } else {
    return originalPathWithNoSlash;
  }
};

export const getBackButtonPathName = (
  originalPath: string,
  gatsbyPathName: string
) => {
  const originalPathWithNoSlash = originalPath.replace(/\/+$/, '');
  const gatsbyPathNameWithNoSlash = gatsbyPathName.replace(/\/+$/, '');
  if (originalPathWithNoSlash.endsWith(gatsbyPathNameWithNoSlash)) {
    return '';
  } else {
    return './';
  }
};

export const getLedgerBalance = (
  current_balance_due: string | number | undefined,
  allowNegativeAmount: boolean = false
) => {
  const balance = Number(current_balance_due);

  if (!isNaN(balance)) {
    if (allowNegativeAmount || balance >= 0) {
      return getDecimalBalance(balance);
    }
  }

  return currentBalanceNotAvailable;
};

export const getAmountToPay = (
  {
    new_balance,
    current_balance_due,
  }: {
    new_balance: string | number | undefined;
    current_balance_due: string | number | undefined;
  },
  allowNegativeAmount: boolean = false
) => {
  const balance = Number(new_balance);
  if (!isNaN(balance)) {
    if (allowNegativeAmount || balance >= 0) {
      return getDecimalBalance(new_balance);
    }
  }
  return getLedgerBalance(current_balance_due);
};
